import React, { useState, useEffect } from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import Editor from "../../../components/admin/Editor";

import "./AddCategory.css";
import { BACKEND_URL } from "../../../config";

function EditCategory() {

  const navigate = useNavigate();

  const { id } = useParams();

  const [loading, setLoading] =
    useState(false);

  const [imagePreview, setImagePreview] =
    useState(null);

  const [file, setFile] =
    useState(null);

  const [keywordInput, setKeywordInput] =
    useState("");

  const [keywordList, setKeywordList] =
    useState([]);

  const [categories, setCategories] = useState([]);

  const [formData, setFormData] =
    useState({
      id: "",
      categoryName: "",
      slug: "",
      description: "",
      metaTitle: "",
      metaDescription: "",
      keywords: "",
      status: "Active",
      date: "",
      image: "",
      parentId: "",
    });

  // ================= FETCH CATEGORY =================

  useEffect(() => {

    fetch(
      `${BACKEND_URL}/api.php?module=category`
    )
      .then((res) => res.json())
      .then((data) => {

        if (data.success) {
          setCategories(data.data);
          const category =
            data.data.find(
              (c) =>
                String(c.id) === String(id)
            );

          if (category) {
            const pId = category.parentId || category.parent_id;
            setFormData({
              ...category,
              parentId: (pId && pId !== "0" && pId !== 0) ? pId : "",
            });

            // keyword tags
            if (category.keywords) {

              setKeywordList(
                category.keywords
                  .split(",")
                  .map((k) => k.trim())
              );

            }

            // image preview
            if (category.image) {

              setImagePreview(
                category.image.startsWith("http")
                  ? category.image
                  : `${BACKEND_URL}/${category.image}`
              );

            }

          }

        }

      });

  }, [id]);

  // ================= AUTO SLUG =================

  useEffect(() => {

    const generatedSlug =
      formData.categoryName
        ?.toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-");

    setFormData((prev) => ({
      ...prev,
      slug: generatedSlug,
    }));

  }, [formData.categoryName]);

  // ================= INPUT =================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

  };

  // ================= KEYWORDS =================

  const handleKeywordKeyDown = (e) => {

    if (
      e.key === "Enter" ||
      e.key === ","
    ) {

      e.preventDefault();

      const value =
        keywordInput.trim();

      if (
        value &&
        !keywordList.includes(value)
      ) {

        const updated = [
          ...keywordList,
          value,
        ];

        setKeywordList(updated);

        setFormData({
          ...formData,
          keywords: updated.join(","),
        });

      }

      setKeywordInput("");

    }

  };

  const removeKeyword = (index) => {

    const updated =
      keywordList.filter(
        (_, i) => i !== index
      );

    setKeywordList(updated);

    setFormData({
      ...formData,
      keywords: updated.join(","),
    });

  };

  // ================= UPDATE =================

  const handleUpdate = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      const form =
        new FormData();

      form.append(
        "action",
        "update"
      );

      form.append(
        "id",
        formData.id
      );

      form.append(
        "categoryName",
        formData.categoryName
      );

      form.append(
        "slug",
        formData.slug
      );

      form.append(
        "description",
        formData.description
      );

      form.append(
        "metaTitle",
        formData.metaTitle
      );

      form.append(
        "metaDescription",
        formData.metaDescription
      );

      form.append(
        "keywords",
        formData.keywords
      );

      form.append(
        "status",
        formData.status
      );

      form.append(
        "date",
        formData.date
      );

      form.append(
        "old_image",
        formData.image || ""
      );

      form.append(
        "parentId",
        formData.parentId || ""
      );

      form.append(
        "parent_id",
        formData.parentId || ""
      );

      // IMAGE

      if (file) {

        form.append(
          "image",
          file
        );

      }

      const response =
        await fetch(
          `${BACKEND_URL}/api.php?module=category`,
          {
            method: "POST",
            body: form,
          }
        );

      const result =
        await response.json();

      if (result.success) {

        alert(
          "Category Updated Successfully ✔"
        );

        navigate(
          "/admin/categories/view"
        );

      } else {

        alert(
          result.message ||
            "Update failed"
        );

      }

    } catch (error) {

      console.log(error);

      alert("Backend error");

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="add-category-page">

      <h2>Edit Category</h2>

      <form onSubmit={handleUpdate}>

        {/* CATEGORY NAME */}

        <label>
          Category Name
        </label>

        <input
          name="categoryName"
          placeholder="Category Name"
          value={
            formData.categoryName
          }
          onChange={handleChange}
        />

        {/* SLUG */}

        <label>Slug</label>

        <input
          name="slug"
          value={formData.slug}
          onChange={handleChange}
        />

        {/* DATE */}

        <label>Date</label>

        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
        />

        <label>Parent Category (Optional)</label>
        <select
          name="parentId"
          value={formData.parentId || ""}
          onChange={handleChange}
        >
          <option value="">None (Is a Parent Category)</option>
          {categories
            .filter((c) => String(c.id) !== String(id) && c.status === "Active")
            .map((c) => (
              <option key={c.id} value={c.id}>
                {c.categoryName}
              </option>
            ))}
        </select>

        {/* DESCRIPTION */}

        <label>
          Description
        </label>

        <Editor
          formData={formData}
          setFormData={setFormData}
        />

        {/* META TITLE */}

        <label>
          Meta Title
        </label>

        <input
          name="metaTitle"
          value={
            formData.metaTitle
          }
          onChange={handleChange}
        />

        {/* META DESCRIPTION */}

        <label>
          Meta Description
        </label>

        <textarea
          name="metaDescription"
          value={
            formData.metaDescription
          }
          onChange={handleChange}
        />

        {/* KEYWORDS */}

        <label>
          Keywords
        </label>

        <input
          type="text"
          placeholder="Enter keyword + Enter"
          value={keywordInput}
          onChange={(e) =>
            setKeywordInput(
              e.target.value
            )
          }
          onKeyDown={
            handleKeywordKeyDown
          }
        />

        <div className="keyword-box">

          {keywordList.map(
            (k, i) => (

              <span
                key={i}
                onClick={() =>
                  removeKeyword(i)
                }
                className="keyword-tag"
              >
                {k} ✖
              </span>

            )
          )}

        </div>

        {/* IMAGE */}

        <label>Image</label>

        <input
          type="file"
          accept=".webp,image/webp"
          onChange={(e) => {

            const file =
              e.target.files[0];

            if (file) {

              if (
                file.type !==
                "image/webp"
              ) {

                alert(
                  "Only WEBP images allowed ❌"
                );

                return;

              }

              setFile(file);

              setImagePreview(
                URL.createObjectURL(
                  file
                )
              );

            }

          }}
        />

        {imagePreview && (

          <img
            src={imagePreview}
            width="200"
            alt=""
          />

        )}

        {/* STATUS */}

        <label>Status</label>

        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
        >

          <option>
            Active
          </option>

          <option>
            Inactive
          </option>

        </select>

        {/* BUTTON */}

        <button
          type="submit"
          disabled={loading}
        >

          {loading
            ? "Updating..."
            : "Update Category"}

        </button>

      </form>

    </div>

  );

}

export default EditCategory;